export default __webpack_public_path__ + "static/media/Pit Fighter's Frayed Choker.4e323103.jpg";